/**
 * 스케줄(데이파팅) 해석 — "이 시각에 이 스케줄은 무엇을 트는가".
 *
 * 답은 플레이리스트일 수도, **콘텐츠 하나**일 수도 있다(규칙이 둘 중 하나를 가리킨다).
 * 평소 편성(어느 규칙에도 안 걸리는 시간)도 둘 중 하나다(2026-10-21) — 예전에는 플레이리스트뿐이라, 평소엔
 * 영상 한 편만 도는 곳도 한 항목짜리 플레이리스트를 따로 만들어야 했다.
 */
import { matchesDaypart, zonedFieldsAt } from './time.js';
/**
 * 규칙 우선순위 비교 — **완전히 결정적**이어야 한다(R2).
 *
 * TalkOne 구현은 `r.priority > best.priority` 만 봤기 때문에 동률일 때 배열 순서가
 * 승자를 정했다. 규칙 순서를 바꾸면(편집 UI 에서 흔하다) 재생물이 조용히 바뀌는,
 * 재현 불가능한 운영 사고가 된다. 여기서는 (우선순위 desc, 규칙 id asc) 로 완전 고정한다.
 */
export function compareRules(a, b) {
    if (a.priority !== b.priority)
        return b.priority - a.priority;
    return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}
/**
 * 주어진 시각에 활성인 규칙을 고른다. 매칭 규칙이 없으면 평소 편성(플레이리스트 또는 콘텐츠).
 *
 * @param timezone 이미 해석된 기준 타임존(디스플레이 → 스케줄 → 서비스 기본값 순, R5).
 */
export function resolveSchedule(schedule, at, timezone) {
    const fields = zonedFieldsAt(at, timezone);
    const active = schedule.rules.filter((rule) => matchesDaypart({ days: rule.days, start: rule.start, end: rule.end }, fields));
    if (active.length > 0) {
        const winner = [...active].sort(compareRules)[0];
        return {
            playlistId: winner.playlistId,
            assetId: winner.assetId,
            ruleId: winner.id,
            matchKey: `rule:${winner.id}`,
        };
    }
    if (schedule.defaultPlaylistId) {
        return {
            playlistId: schedule.defaultPlaylistId,
            assetId: null,
            ruleId: null,
            matchKey: 'default',
        };
    }
    if (schedule.defaultAssetId) {
        return { playlistId: null, assetId: schedule.defaultAssetId, ruleId: null, matchKey: 'default' };
    }
    return { playlistId: null, assetId: null, ruleId: null, matchKey: 'none' };
}
//# sourceMappingURL=schedule.js.map